// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"07b3d347","703":"05d2ea25","787":"09e1aeb7"}[chunkId] + ".chunk.js";
};